import SilverRupee from "../../../core/assets/oot/classic/silver_rupee.png"
import { Box, Tooltip } from "@mui/material";
import StaticItem from "../../../core/items/StaticItem";
import { SimpleItemProps } from "./SimpleItemProps";

interface SilverRupeeItemProps {
    pouch: boolean
    location: string,
    isObtained: boolean
    setIsObtained: (v: string) => void
    count?: number,
    setCount?: (v: number) => void
}

const SilverRupeeItem = (props: SilverRupeeItemProps) => {


    return <Tooltip title={props.location}>
        <Box display={"flex"}  sx={{ filter: !props.isObtained ? "grayscale(100%) brightness(0.6)" : "none"}} onClick={() => props.setIsObtained(props.location)}>
            {props.isObtained && props.pouch && <img alt="silver" src={SilverRupee} height={28} width={28}/>}
            {!props.isObtained && <img alt="silver"  src={SilverRupee} height={28} width={28} />}
        </Box>
    </Tooltip> 
    
    

}

export default SilverRupeeItem;

export const SimpleSilverRupeeItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={SilverRupee}
        onClick={props.onClick}
        name={"silver"}
    />

}
